import { Action, createAction, handleActions } from 'redux-actions'

import { reset } from '@/utils/reducerUtils'

export const VERSION = 'version'

export const SET_VERSION = `${VERSION}/set-version`
export const RESET_VERSION = `${VERSION}/reset-version`

export const versionActions = {
  set: createAction<string>(SET_VERSION),
  reset: createAction(RESET_VERSION),
}

interface IVersionState {
  version?: string
}
const initialState: IVersionState = {}

export const reducer = {
  [SET_VERSION]: (state: IVersionState, action: Action<string>) => ({
    ...state,
    version: action.payload,
  }),
  [RESET_VERSION]: (state: IVersionState) => reset(state, initialState),
}

export const versionReducer = handleActions(reducer, initialState)
